import { Components, Theme } from "@mui/material";

declare module "@mui/material/FormLabel" {}

export const MuiFormLabel: Components<Theme>["MuiFormLabel"] = {
  styleOverrides: {
    asterisk: ({ theme }) => {
      const {
        palette: { error },
      } = theme;

      return {
        float: "left",
        color: error.main,
        marginRight: "0.25rem",
      };
    },
  },
};
